import React from 'react'

import { colors } from '~tokens/internal'

interface EmailSentIconProps {
  width?: number
  height?: number
  alt?: string
  color?: string
}

const EmailSentIcon: React.FC<EmailSentIconProps> = ({
  width = 24,
  height = 24,
  alt = 'Email sent icon',
  color = colors.teal[50],
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      aria-label={alt}
    >
      <title>{alt}</title>
      <mask
        id='mask0_emailsent'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='24'
        height='24'
      >
        <rect width='24' height='24' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_emailsent)'>
        <path
          d='M19 23L17.6 21.6L19.175 20H15V18H19.175L17.575 16.4L19 15L23 19L19 23ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V13.8C21.55 13.5333 21.0708 13.3333 20.5625 13.2C20.0542 13.0667 19.5333 13 19 13C17.3333 13 15.9167 13.5833 14.75 14.75C13.5833 15.9167 13 17.3333 13 19V20H4ZM12 13L20 8V6L12 11L4 6V8L12 13Z'
          fill={color}
        />
      </g>
    </svg>
  )
}

export default EmailSentIcon
